import React, { useEffect, useState } from "react";
import axios from "axios";

const Disclaimer = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/careers`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setData(events.Disclaimer);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);

  if (!data) return null;

  return (
    <div className="w-full px-6 py-8 bg-gray-100 text-gray-700 md:px-16 lg:px-32">
      <h2 className="text-2xl font-bold text-center text-gray-800 md:text-3xl">
        {data.title}
      </h2>
      <p className="mt-4  text-base md:text-base">{data.description}</p>
      <p className="mt-6 text-base  md:text-base">
        <span className="font-bold">{data.warningTitle}: </span>
        {data.warningMessage}
      </p>
      <p className="mt-4  text-base md:text-base">
        {data.contactText}
        <a href={`mailto:${data.contactEmail}`} className="text-blue-600 font-bold">
          {data.contactEmail}
        </a>
      </p>
    </div>
  );
};

export default Disclaimer;
